import { request } from './apiClient';
import { getSessionClientId } from './authSession';

// Lista as etapas de obra natas (catálogo padrão) somadas às do cliente da sessão.
export const getEtapaObra = async (idCliente) => {
    const effectiveClientId = idCliente || getSessionClientId();
    return await request(`/api/etapaObra?idCliente=${effectiveClientId}`);
};

// Lista as etapas de obra natas somadas às da empresa informada, já restritas ao cliente da sessão.
export const getEtapaObraEmpresa = async (idEmpresa) => {
    return await request(`/api/etapaObra/EtapaObraEmpresa/${idEmpresa}`);
};

// Cria uma etapa de obra. Sem idEmpresa, vale para todas as empresas do cliente.
export const createEtapaObra = async (etapaObraData) => {
    return await request("/api/etapaObra", {
        method: 'POST',
        body: JSON.stringify(etapaObraData)
    });
};

// Atualiza uma etapa de obra por id.
export const updateEtapaObra = async (idEtapaObra, etapaObraData) => {
    return await request(`/api/etapaObra/${idEtapaObra}`, {
        method: 'PUT',
        body: JSON.stringify(etapaObraData)
    });
};

// Exclui uma etapa de obra por id.
export const deleteEtapaObra = async (idEtapaObra) => {
    return await request(`/api/etapaObra/${idEtapaObra}`, {
        method: 'DELETE'
    });
};
